import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { removeToken } from './auth'
import { MessageBox, Message } from "element-ui";

function generateUUID() {
  return 'xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
// create an axios instance
// 创建一个axios实例
// console.log(process.env.VUE_APP_BASE_API, 'process.env.VUE_APP_BASE_API')
const request = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 600 * 1000, // request timeout,
  headers: {
    ClientId: '01000000',
    ReqTime: Date.now().toString(),
  }
})

// 请求拦截器
request.interceptors.request.use(
  (config) => {
    const token = store.state.user.token
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    config.headers.ReqId = generateUUID()
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// 响应拦截器
request.interceptors.response.use(
  (response) => {
    if (response.data instanceof Blob) return response.data

    const { code, msg } = response.data
    if (code == 0) {
      return response.data
    } else {
      Message({
        type: 'error',
        message: msg
      })
      // console.error('接口调用失败:', msg);

      return Promise.reject(msg)

    }
    // return response.data
  },
  (error) => {
    Message({
        type: 'error',
        message: msg
  })
    return Promise.reject(error)
  }
)

export default request
